<!-- src/components/views/paciente/ActividadFisica.vue -->
<template>
  <div class="w-full sm:m-auto sm:w-max sm:items-center flex flex-col gap-3 ">
    <h2 class="font-bold text-xl text-center p-2">Registro de Actividad Física</h2>

    <div class="w-full flex flex-col gap-3">
      <label for="tipoActividad">Tipo de Actividad:</label>
      <select v-model="nuevaActividad.tipo" id="tipoActividad"
        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
        <option value="Cardio">Cardio</option>
        <option value="Pesas">Pesas</option>
        <option value="Bajo Impacto">Bajo Impacto</option>
        <option value="Caminata">Caminata</option>
        <option value="Jogging">Jogging</option>
        <option value="Alta Intensidad">Alta Intensidad</option>
        <option value="Otro">Otro</option>
      </select>

      <label for="duracion">Tiempo (minutos):</label>
      <input v-model="nuevaActividad.duracion" type="number" id="duracion"
        class="block w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Ejemplo: 30" />

      <label for="horaActividad">Hora de la Actividad:</label>
      <TimePicker v-model="nuevaActividad.hora" placeholder="Seleccionar hora" />
      <label for="notas">Notas:</label>
      <textarea v-model="nuevaActividad.notas" id="notas"
        class="block w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Agregar notas (opcional)"></textarea>

      <button @click="agregarActividad"
        class="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-full whitespace-nowrap">Añadir
        Actividad</button>
    </div>

    <div class="w-full flex flex-col gap-2 mt-4">
      <h3>Historial de Actividades</h3>
      <div v-if="actividades.length">
        <ul class="flex flex-col p-6 gap-5">
          <li v-for="(actividad, index) in actividades" :key="index">
            <p><strong>Tipo:</strong> {{ actividad.tipo }}</p>
            <p><strong>Duración:</strong> {{ actividad.duracion }} minutos</p>
            <p><strong>Hora:</strong> {{ actividad.hora }}</p>
            <p><strong>Notas:</strong> {{ actividad.notas || 'N/A' }}</p>
            <button @click="eliminarActividad(index, actividad.id)"
              class="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 w-full whitespace-nowrap">Eliminar</button>
          </li>
        </ul>
      </div>
      <div v-else>
        <p>No hay actividades registradas aún.</p>
      </div>
    </div>

    <div class="mt-4">
      <h3>Progreso de Actividad Física</h3>
      <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
        <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full"
          :style="{ width: progresoTotal + '%' }">
          {{ progresoTotal }}%
        </div>
      </div>
      <p>¡Sigue así! A medida que agregues más actividades, tu progreso aumentará.</p>
    </div>
  </div>
</template>

<script>
import { getAuth } from 'firebase/auth';
import { collection, addDoc, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db } from "@/firebase"; 
import TimePicker from './TimePicker.vue';
export default {
  name:  'ActividadFisica',
  components: {TimePicker} ,
  data() {
    return {
      nuevaActividad: {
        tipo: '',
        duracion: 0,
        hora: '',
        notas: ''
      },
      actividades: [],
      pacienteId: null, // Variable para almacenar el pacienteId
    };
  },
  computed: {
    progresoTotal() {
      const totalMinutos = this.actividades.reduce((suma, actividad) => suma + actividad.duracion, 0);
      const meta = 300; // Meta de minutos de actividad por semana, ajustable
      return Math.min((totalMinutos / meta) * 100, 100).toFixed(1);
    }
  },
  methods: {
    obtenerPacienteId() {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        this.pacienteId = user.uid; // Obtener el pacienteId desde el UID del usuario autenticado
      } else {
        console.error("No hay un usuario autenticado.");
      }
    },
    async agregarActividad() {
      if (this.nuevaActividad.tipo && this.nuevaActividad.duracion > 0 && this.nuevaActividad.hora && this.pacienteId) {
        try {
          const docRef = await addDoc(collection(db, `pacientes/${this.pacienteId}/actividades`), {
            ...this.nuevaActividad,
            fecha: new Date() // Agregar la fecha actual automáticamente
          });
          this.actividades.push({ ...this.nuevaActividad, id: docRef.id });
          this.nuevaActividad = { tipo: '', duracion: 0, hora: '', notas: '' };
        } catch (error) {
          console.error("Error al agregar la actividad:", error);
        }
      } else {
        alert('Por favor, complete todos los campos obligatorios.');
      }
    },
    async eliminarActividad(index, actividadId) {
      try {
        await deleteDoc(doc(db, `pacientes/${this.pacienteId}/actividades`, actividadId));
        this.actividades.splice(index, 1);
      } catch (error) {
        console.error("Error al eliminar la actividad:", error);
      }
    },
    async cargarActividades() {
      try {
        const querySnapshot = await getDocs(collection(db, `pacientes/${this.pacienteId}/actividades`));
        this.actividades = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } catch (error) {
        console.error("Error al cargar actividades:", error);
      }
    }
  },
  async mounted() {
    this.obtenerPacienteId();
    if (this.pacienteId) {
      await this.cargarActividades();
    }
  }
};
</script>

<style scoped>
</style>
